"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./style.css");
var CodeLineNumbers = /** @class */ (function () {
    function CodeLineNumbers() {
    }
    CodeLineNumbers.addCodeLineNumbers = function (selector) {
        if (selector === void 0) { selector = CodeLineNumbers.DEFAULT_SELECTOR; }
        var els = document.querySelectorAll(selector);
        for (var i = 0; i < els.length; i++)
            CodeLineNumbers.addLineNumbersTo(els[i]);
    };
    CodeLineNumbers.addLineNumbersTo = function (elCode) {
        var lines = elCode.innerHTML.split("\n");
        if (lines.length === 0 || (lines.length === 1 && lines[0].length === 0))
            return;
        var digitsCount = ("" + lines.length).length;
        for (var n = 0; n < lines.length; n++) {
            var lineNumber = n + 1;
            var numberWithZeros = "" + lineNumber;
            if (numberWithZeros.length < digitsCount) {
                var zeros = "";
                for (var i = 0; i < digitsCount - numberWithZeros.length; i++)
                    zeros += "0";
                numberWithZeros = "<span class=\"code-line-numbers__number__zeros\">" + zeros + "</span>" + lineNumber;
            }
            lines[n] = "<span class=\"code-line-numbers__number\">" + numberWithZeros + "</span>" + lines[n];
        }
        elCode.innerHTML = lines.join("\n");
    };
    CodeLineNumbers.DEFAULT_SELECTOR = "pre > code";
    return CodeLineNumbers;
}());
exports.CodeLineNumbers = CodeLineNumbers;
